import axios from "axios";
import HttpException from "../common/exceptions/HttpException";
import { SSO_REFRESH_TOKEN } from "../constants/APIConstants";

// Refreshes at the SSO API of the environment the refresh token came from.
export const ssoRefreshToken = async (payload, env) => {
  const response = await axios
    .post(env.ssoApi + SSO_REFRESH_TOKEN, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch(HttpException.create);
  return response.data;
};
